export default __webpack_public_path__ + "static/media/carpeta.fe3b12a1.svg";